export const itemWithoutCombinedListingWithoutAdditionalRibbons = `  id
      options {
        id
        key
        title @include(if: $withOptions)
        optionType @include(if: $withOptions)
        selections @include(if: $withOptions) {
          id
          value
          description
          key
          inStock
          visible
          linkedMediaItems {
            url
            fullUrl
            width
            height
          }
        }
      }
      productItems @include(if: $withOptions) {
        id
        optionsSelections
        price
        comparePrice
        formattedPrice
        formattedComparePrice
        hasDiscount
        availableForPreOrder
        isTrackingInventory
        inventory {
          status
          quantity
        }
        automaticDiscount {
          automaticDiscountPrice
          formattedAutomaticDiscountPrice
          automaticDiscountPricePerUnit
          formattedAutomaticDiscountPricePerUnit
        }
        isVisible
        pricePerUnit
        formattedPricePerUnit
        preOrderInfo {
          limit
          message
        }
      }
      customTextFields(limit: 1) {
        title
      }
      productType
      ribbon
      price
      comparePrice
      pricePerUnit
      sku
      isInStock
      urlPart
      formattedComparePrice
      formattedPrice
      formattedPricePerUnit
      pricePerUnitData {
        baseQuantity
        baseMeasurementUnit
      }
      itemDiscount {
        discountRuleName
        automaticDiscountRuleNames
        priceAfterDiscount
        priceAfterDiscountAmount
        automaticDiscountPricePerUnit
        formattedAutomaticDiscountPricePerUnit
      }
      digitalProductFileItems {
        fileType
      }
      name
      currency
      media {
        url
        fullUrl
        width
        height
        altText
      }
      isManageProductItems
      productItemsPreOrderAvailability
      isTrackingInventory
      inventory {
        status
        quantity
        availableForPreOrder
        preOrderInfoView {
          limit
        }
      }
      subscriptionPlans {
        list {
          id
          visible
        }
      }
      priceRange(withSubscriptionPriceRange: true) @include(if: $withPriceRange) {
        fromPrice
        fromPriceFormatted
      }
      discount {
        value
      }`;
